export const focusFirstAvailableSeat = () => {
  const seatButtons = document.querySelectorAll('[data-seat-id]');
  for (const button of seatButtons) {
    if (!button.disabled) {
      button.focus();
      break;
    }
  }
};
export const handlePNRKeyDown = e => {
  if ((e.key === 'Enter' || e.key === ' ') && e.currentTarget === e.target) {
    e.preventDefault();
    focusFirstAvailableSeat();
  }
};
//# sourceMappingURL=SeatMapMainContentUtils.js.map